// Lib
import React from 'react';

// Components
import Button from '../../../Button';

import { useStyles } from './ActionButtonsStyles';

const ActionButtons = ({
  className,
  onReject = () => {},
  onAccept = () => {},
  status,
}) => {
  const { classes, cx } = useStyles({ status });

  return (
    <div className={cx(classes.buttons, className)}>
      <Button onClick={onReject} variant="text">
        {`Reject${status === 'reject' ? 'ed' : ''}`}
      </Button>
      <Button id="approve-btn" onClick={onAccept('approve')}>{`Approve${
        status === 'approve' ? 'd' : ''
      }`}</Button>
    </div>
  );
};

export default ActionButtons;
